import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { PathBuilder } from 'src/routing/paths';

const getCardLink = (siteId: number, componentId: string, linkTagsIds?: string[]) => {
  if (linkTagsIds && linkTagsIds.length > 0) {
    return PathBuilder.ANALYSIS_QUERY(siteId, linkTagsIds);
  }
  return null;
};

const useStyles = makeStyles(() => ({
  forcePointer: {
    cursor: 'pointer',
    '& *': {
      cursor: 'pointer',
    },
  },
}));

interface CardLinkProps {
  children: React.ReactNode;
  linkTagsIds?: string[];
  siteId: number;
  componentId: string;
}

const CardLink = ({ children, linkTagsIds, siteId, componentId, ...props }: CardLinkProps) => {
  const classes = useStyles();

  const linkTo = getCardLink(siteId, componentId, linkTagsIds);

  if (!linkTo) {
    return <>{children}</>;
  }

  return (
    <Link
      component={RouterLink}
      to={linkTo}
      underline="none"
      {...props}
      className={classes.forcePointer}
    >
      {children}
    </Link>
  );
};

export default CardLink;
